import { getUrlParams } from '@rambler-id/url';
import { removeItem, setItem, getItem } from '@rambler-id/local-storage';
const RESET_DEBUG_LOCAL_STORAGE_VALUE = 'unset';
export const activateDebug = (href) => {
    if (typeof window === 'undefined')
        return;
    const { debug: debugQueryParam } = getUrlParams(href ?? window.location.href);
    const debugLocalStorageParam = getItem('debug', { raw: true });
    if (!debugQueryParam ||
        typeof debugQueryParam !== 'string' ||
        debugLocalStorageParam === debugQueryParam ||
        (!debugLocalStorageParam &&
            debugQueryParam === RESET_DEBUG_LOCAL_STORAGE_VALUE))
        return;
    if (debugQueryParam === RESET_DEBUG_LOCAL_STORAGE_VALUE) {
        removeItem('debug');
    }
    else {
        setItem('debug', debugQueryParam, { raw: true });
    }
};
export { default as createDebug } from 'debug';
